/* eslint-disable react/prop-types */
import React from 'react';
import { SectionCard } from '../../../../ui';
import ProTable from '@ant-design/pro-table';

import { guuid } from '@/utils/utils';
import { querySignAli, contractDocuments } from '@/services/coachCalendar';
import { signAliColumns, contractDocumentsColumns } from './alipayColumns';
import styles from '../index.less';

/**
 * 成员详情 · 支付宝签约
 * ------------------------------------------------------------------
 * 2026-09-17 从 coachProfile/index.jsx 抽出（S1：6 页签 → 单页 + 右侧锚点）：
 * 本区块原占 80 行，连同两套表格列定义（原 216 行）一起搬进来 —— 这两套列定义
 * 只被本区块使用，所以一并搬走，容器不再持有。
 *
 * 两个 ProTable 的 actionRef 由容器传入：容器的「标记失效」「改绑支付宝」
 * 成功后要 reload 它们。
 *
 * 本区块套了 LazyMount（两张表较重，滚到视口再挂载）；但**表单那三个区块
 * 不能套** —— 容器要拿它们的 ref 灌初始值，必须常驻挂载。
 */

export const AlipaySection = ({
  coachData,
  coachUserId,
  actionRef,
  actionRef1,
  /* 两套列定义里的按钮要回调容器里的 handler / setter：
     标记失效、查看人脸视频、改绑支付宝，所以由容器传入 */
  handleMarkSignInvalid,
  setFaceVideoUrl,
  setFaceVideoVisible,
  setIsAlipayModalVisible,
  setNewAlipayAccount,
}) => (
  <SectionCard title="支付宝签约">
    <ProTable
      columns={signAliColumns({
        handleMarkSignInvalid,
        setFaceVideoUrl,
        setFaceVideoVisible,
        setIsAlipayModalVisible,
        setNewAlipayAccount,
      })}
      actionRef={actionRef}
      request={async (params) => {
        const { data, code } = await querySignAli({
          requestData: {
            coachId: coachData.coachId,
          },
        });
        if (code !== '00000') {
          return {
            success: false,
          };
        }
        const cache = [];
        cache.push({ ...data });
        return {
          data: cache,
          success: true,
        };
      }}
      columnsState={{
        persistenceKey: 'pro-table-singe-demos',
        persistenceType: 'localStorage',
      }}
      rowKey={() => guuid()}
      search={false}
      pagination={false}
      scroll={{ x: 'max-content' }}
      toolBarRender={false}
      dateFormatter="string"
    />
    <div className={`${styles.sectionTitle} ${styles.sectionTitleSpaced}`}>
      合同文件
    </div>
    <ProTable
      columns={contractDocumentsColumns({
        handleMarkSignInvalid,
        setFaceVideoUrl,
        setFaceVideoVisible,
        setIsAlipayModalVisible,
        setNewAlipayAccount,
      })}
      actionRef={actionRef1}
      request={async (params) => {
        const { data, code } = await contractDocuments({
          requestData: {
            userId: coachUserId,
          },
        });

        if (code !== '00000') {
          return {
            success: false,
          };
        }
        const cache = [
          data || {
            gmtModified: '-',
            contractDocuments: [],
            solutionCode: '-',
          },
        ];
        // cache.push({ ...data });
        return {
          data: cache,
          success: true,
        };
      }}
      columnsState={{
        persistenceKey: 'pro-table-singe-demos',
        persistenceType: 'localStorage',
      }}
      rowKey={() => guuid()}
      search={false}
      pagination={false}
      scroll={{ x: 'max-content' }}
      toolBarRender={false}
      dateFormatter="string"
    />
  </SectionCard>
);

export default AlipaySection;
